import { render, staticRenderFns } from "./custodyStatement.vue?vue&type=template&id=7e5dbaa5"
import script from "./custodyStatement.vue?vue&type=script&lang=js"
export * from "./custodyStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports